// extracted by mini-css-extract-plugin
export default {"root":"BottomContent__root--dZ6wD"};